import { render } from "./UnhealtyTutorialBuddy.vue?vue&type=template&id=2d4b74dc&scoped=true"
import script from "./UnhealtyTutorialBuddy.vue?vue&type=script&lang=js"
export * from "./UnhealtyTutorialBuddy.vue?vue&type=script&lang=js"

import "./UnhealtyTutorialBuddy.vue?vue&type=style&index=0&id=2d4b74dc&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4b74dc"]])

export default __exports__